const ExportDataList = () => import('Views/userCenter/export-data-list');
const DataBackup = () => import('Views/userCenter/data-backup');

export default[
  { path: '/export-data-list', component: ExportDataList },
  { path: '/data-backup', component: DataBackup },
];



// WEBPACK FOOTER //
// ./src/router/exportData.js